module.exports = __webpack_public_path__ + "static/media/rv_logo.cbc29b6a.png";